define(function (require) {
    'use strict';

    var Marionette = require('marionette');
    var ModalsFactory         = require('modals/factory');

    return Marionette.Behavior.extend({
        ui: {
            element: '.js-about',
        },

        events: {
            'click @ui.element': 'showAbout',
        },

        showAbout: function() {
            var that = this;

            ModalsFactory.create('content_dialog', function(Modal) {
                var modal =  new Modal({
                    modalData: {
                        width: 1100,
                        content: this.view.options.aboutPopup,
                        hideTitle: true,
                        background: '#fff'
                    }
                });
                app.regionModal.show(modal);
                modal.$('.js-arcticmodal').click(function() {
                    var template = $(this).data('template');

                    if (modal.$('#' + template).length) {
                        modal.$('#' + template).arcticmodal();
                    }
                });

                modal.$('.js-start-use-page').click(function(event) {
                    event.preventDefault();
                    Backbone.ajax({
                        type: 'POST',
                        url: AppConfig.host + '/system/menu_html_big_button_clicked',
                        data: JSON.stringify({status: 1, menu_id: this.options.menu.id}),
                        success: function() {
                            that.options.menu.button_clicked = 1;
                            Backbone.history.loadUrl(Backbone.history.fragment);
                        }
                    })
                })
            }.bind(this));
        }
    })
});